// extracted by mini-css-extract-plugin
module.exports = {"cart-items":"Cart_cart-items__RKm7G","total":"Cart_total__350bY","actions":"Cart_actions__2_9x1","button--alt":"Cart_button--alt__3WIib","button":"Cart_button__2d1dp"};